// components/Alert.js
import React from 'react';

const Alert = ({ message, onClose }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-lg p-6 max-w-lg w-full">
        <div className="text-center text-gray-800 break-words">{message}</div>
        <div className="mt-4 flex justify-center">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-teal-500 text-white rounded hover:bg-teal-700"
          >
            Understood
          </button>
        </div>
      </div>
    </div>
  );
};

export default Alert;
